import type { ClickAwayListenerProps } from "@material-ui/core";
import { ClickAwayListener as MuiClickAwayListener } from "@material-ui/core";
import React from "react";
export function ClickAwayListener(props: ClickAwayListenerProps) {
    return <MuiClickAwayListener {...props}>{props.children}</MuiClickAwayListener>;
}
